import {
  CustomizationButton,
  CustomizationFooterButtonsContainer,
  CustomizationFooterContainer,
  CustomizationFooterImage,
  CustomizationFooterText,
} from './components';

export const CustomizationFooter = {
  Container: CustomizationFooterContainer,
  Image: CustomizationFooterImage,
  Text: CustomizationFooterText,
  Button: CustomizationButton,
  ButtonsContainer: CustomizationFooterButtonsContainer,
};
